export enum PatientSelectionModalKeys {
  LIST = 'LIST',
  CREATE = 'CREATE',
  PHONE_CONFIRMATION = 'PHONE_CONFIRMATION',
}
